<template>
  <Head title="Settings - Agency Permission" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <team-agency-edit :client="client" :agency="agency" :user_logged_in="user_logged_in"></team-agency-edit>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../Layouts/AppLayout.vue';

defineProps({
  client: Object,
  agency: Object,
  user_logged_in: Object
});
</script>

